export enum ModalJobType {
  NewJob = 'New job',
  EditJob = 'Edit job position',
  Duplicate = 'Duplicate',
}
